var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about_bg"},[_c('div',[_c('header',[_c('el-image',{attrs:{"src":_vm.iconHeader}}),_vm._v(" "),_c('span',{staticClass:"title_font"},[_vm._v("联系我们")])],1),_vm._v(" "),_c('div',{staticClass:"title_line"}),_vm._v(" "),_c('body',[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.htmlInfo)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa9461a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutWe.vue
// module id = null
// module chunks = 